import DeleteItemIcon from "../../../assets/delete-item.svg";
import EditItemIcon from "../../../assets/edit-item.svg";
import SortableTh from "../../shared/SortableTh";

const ViewClientPermissions = ({
  data,
  sort,
  order,
  onSort,
  editHandler,
  deleteHandler,
  isLoadingDelete,
  menus,
  menuFilter,
  setMenuFilter
}) => {
  return (
    <div className='table-responsive bg-light p-3 mt-2'>
      <div className='d-flex gap-2 align-items-center my-2 flex-wrap'>
        <span className='text-muted small'>Filter by menu:</span>
        <button
          className={`btn btn-sm ${menuFilter === '' ? 'btn-secondary' : 'btn-outline-secondary'}`}
          onClick={() => setMenuFilter('')}
        >All</button>
        {(menus || []).map((m) => (
          <button
            key={m}
            className={`btn btn-sm ${menuFilter === m ? 'btn-primary' : 'btn-outline-primary'}`}
            onClick={() => setMenuFilter(m)}
          >
            {m}
          </button>
        ))}
      </div>
      <table className='table table-sm table-border'>
        <thead className='border-0'>
        <tr>
          <SortableTh label='Name' field='name' sort={sort} order={order} onSort={onSort}/>
          <SortableTh label='Menu' field='menu' sort={sort} order={order} onSort={onSort}/>
          <SortableTh label='Menu Sorting' field='menu_order' sort={sort} order={order} onSort={onSort}/>
          <SortableTh label='Path' field='path' sort={sort} order={order} onSort={onSort}/>
          <th>Description</th>
          <th>Actions</th>
        </tr>
        </thead>

        <tbody>
          {data &&
            data.data.map((clientPermission) => (
                <tr key={clientPermission._id}>
                  <td>{clientPermission.name}</td>
                  <td>{clientPermission.menu}</td>
                  <td>{clientPermission.menu_order}</td>
                  <td>{clientPermission.path}</td>
                  <td>{clientPermission.description}</td>
                  <td>
                    <div className='btn-group'>
                      <button
                          className='btn'
                          onClick={() => editHandler(clientPermission)}
                          data-bs-toggle='modal'
                          data-bs-target='#clientPermissionModal'
                      >
                        <img src={EditItemIcon} alt="Edit"
                             className="icon-img action-icons-img"/>
                      </button>

                      <button
                          className='btn'
                          onClick={() => deleteHandler(clientPermission._id)}
                          disabled={isLoadingDelete}
                      >
                        {isLoadingDelete ? (
                            <span className='spinner-border spinner-border-sm'/>
                        ) : (
                            <span>
        <img src={DeleteItemIcon} alt="Delete"
             className="icon-img action-icons-img"/>
                        </span>
                        )}
                      </button>
                    </div>
                  </td>
                </tr>
            ))}
        </tbody>
      </table>
    </div>
  )
}

export default ViewClientPermissions
